import { createAction, props } from '@ngrx/store';
import { NotificationsResponse } from '../models';

export const loadNotifications = createAction(
    '[Notifications] Load Notifications',
    props<{ cursor?: string | null }>()
);

export const loadNotificationsSuccess = createAction(
    '[Notifications] Load Notifications Success',
    props<{
        data: NotificationsResponse;
        loading_more?: boolean;
    }>()
);

export const loadNotificationsFailure = createAction(
    '[Notifications] Load Notifications Failure',
    props<{ error: any }>()
);

export const markNotificationAsRead = createAction(
    '[Notifications] Mark Notification As Read',
    props<{ id: number }>()
);

export const markNotificationAsReadSuccess = createAction(
    '[Notifications] Mark Notification As Read Success',
    props<{ id: number }>()
);

export const markNotificationAsReadFailure = createAction(
    '[Notifications] Mark Notification As Read Failure',
    props<{ id: number; error: any }>()
);
